import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'robCaseController';
export default {
    /**
     * 获取抢案案件数据
     */
    robCasesQuery: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'robCasesQuery',
        type: requestType.Get
    },
    /**
     * 获取抢案案件跟进记录
     */
    queryFollowupRecords: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryFollowupRecords',
        type: requestType.Get
    },
    /**
     * 抢案--分案
     */
    distributeRobCase: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'distributeRobCase',
        type: requestType.Post
    },
};
